/** @prettier */
import {Button, Grid, Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

//type import
import {GraphFormType} from '../../../../Type/TypeDef';

import {iconBlack, iconRed} from '../../../../define';

/**
 * 棒グラフと折れ線グラフの切り替えボタン
 * @param props props
 * @returns JSX.Element
 */
export const PowerTrendSelectButton = (props: {
  /** グラフの種類 */
  graphType: GraphFormType;
  /** 切り替え時の処理 */
  selectPowerTrend?: (type: GraphFormType) => void;
  /** 折れ線グラフを無効にするかどうか */
  disableTrend?: boolean;
}) => {
  const {graphType, selectPowerTrend = () => {}, disableTrend = false} = props;

  const trans = useTranslation().t; //翻訳関数

  /** グラフアイコンの切り替えテーブル */
  const graphIconColor: {[key: string]: {bar: string; line: string}} = {
    '': {bar: iconRed.BAR_GRAPH.src, line: iconBlack.LINE_GRAPH.src},
    'bar': {bar: iconRed.BAR_GRAPH.src, line: iconBlack.LINE_GRAPH.src},
    'line': {bar: iconBlack.BAR_GRAPH.src, line: iconRed.LINE_GRAPH.src},
  };

  /**
   * グラフ切り替え時の処理
   * @param type グラフの種類
   */
  const selectGraphHandle = (type: GraphFormType) => {
    selectPowerTrend(type);
  };

  return (
    <Grid
      container
      justifyContent="flex-end"
      className="graph__graphTypeSelect">
      <Grid item xs="auto">
        <Button
          onClick={() => selectGraphHandle('bar')}
          startIcon={
            <img
              className="graph__graphTypeSelect__icon"
              src={graphIconColor[graphType].bar}
              alt={`${trans(
                'PowerTrendButton.image.alternativeText.barGraph'
              )}`}
            />
          }>
          <Box
            component="span"
            className={`graph__graphTypeSelect__text ${
              graphType === 'bar'
                ? 'graph__graphTypeSelect__text--selected'
                : 'graph__graphTypeSelect__text--notSelected'
            }`}>
            {trans('PowerTrendButton.buttonTxt.powerConsumption')}
          </Box>
        </Button>
      </Grid>
      <Grid item xs="auto">
        <Button
          disabled={disableTrend}
          onClick={() => selectGraphHandle('line')}
          startIcon={
            <img
              className="graph__graphTypeSelect__icon"
              src={graphIconColor[graphType].line}
              alt={`${trans(
                'PowerTrendButton.image.alternativeText.lineGraph'
              )}`}
            />
          }>
          {disableTrend === true ? (
            //無効の場合、灰色表記
            <Box component="span" className={'graph__graphTypeSelect__text'}>
              {trans('PowerTrendButton.buttonTxt.trendReporting')}
            </Box>
          ) : (
            <Box
              component="span"
              className={`graph__graphTypeSelect__text ${
                graphType === 'line'
                  ? 'graph__graphTypeSelect__text--selected'
                  : 'graph__graphTypeSelect__text--notSelected'
              }`}>
              {trans('PowerTrendButton.buttonTxt.trendReporting')}
            </Box>
          )}
        </Button>
      </Grid>
    </Grid>
  );
};
